import { Observable } from "rxjs"
import { ObservableFromFetch } from "../ObservableFromFetch"
import SendTextMessage from "./OrderRequestsModel/SendTextMessage"
import SentTextMessage from "./OrderRequestsModel/SentTextMessage"

export default function SendMessageObservable(params: SendTextMessage): Observable<SentTextMessage> {
  const requestBody: string = JSON.stringify({
    EmailAddress: params.EmailAddress,
    Message: params.Message,
    TestDetailIDs: params.TestDetailIDs,
    TestDetailID: params.TestDetailID ,
    TestDetailClinicalIDs: params.TestDetailClinicalIDs,
    ClientDetails: {
      // TODO: ContactID: VALUESTORAGE.CONTACT_ID
    },
  })

  return ObservableFromFetch<SentTextMessage>("WorkforceOrder/SendTextMessage", requestBody)
}
